import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { PersistentIssueCreateModalViewResource } from './PersistentIssueCreateModalView.types.tsx';

export const persistentIssueCreateModalViewResource: RouteResource<PersistentIssueCreateModalViewResource> =
	createResource<PersistentIssueCreateModalViewResource>({
		type: 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW',
		getKey: () => 'state',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-router-resources-persistent-issue-create-modal-view", jiraSpaEntry: "async-router-resources-persistent-issue-create-modal-view" */ './getData.tsx'
			),
		maxAge: Number.MAX_VALUE,
		isCritical: true,
	});
